import { useEffect, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { useSession } from "@hooks/useSession";
import { FormWrapper } from "@pages/user/newptw/form-context";
import { PtwSettingsWrapper } from "@pages/admin/ptw/workflows/workFlow-context";
import { ThemeProvider } from "@config/ThemeContext";
import PropTypes from "prop-types";

function AppContent({ children }) {
  const { session } = useSession();

  useEffect(() => {
    if (session?.theme) {
      document.documentElement.setAttribute("data-theme", session.theme);
    }
  }, [session?.theme]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider>
        <CssBaseline />
        <PtwSettingsWrapper>{children || <Outlet />}</PtwSettingsWrapper>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

AppContent.propTypes = {
  children: PropTypes.node,
};

export default function App() {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
          },
        },
      }),
    []
  );

  return (
    <QueryClientProvider client={queryClient}>
      <FormWrapper>
        <AppContent />
      </FormWrapper>
    </QueryClientProvider>
  );
}
